module.exports = __webpack_public_path__ + "img/ru-store.180ce2810f0e.svg";